import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMusic,
  faCircleExclamation,
  faArrowRight
} from "@fortawesome/free-solid-svg-icons";

export default function NoSubscription({title, message, buttonText, url}) {
  return (
    <div className="min-h-screen bg-gray-100 text-white flex items-center justify-center px-4">
      <div className="bg-gray-950/80 backdrop-blur-lg border border-zinc-800 rounded-2xl shadow-2xl p-10 max-w-xl text-center">
        <FontAwesomeIcon icon={faCircleExclamation} size="3x" className="text-yellow-400 mb-4" />
        <h1 className="text-3xl font-bold mb-3">{title}</h1>
        <p className="text-zinc-400 mb-6 text-lg">
          {message}
        </p>
        <FontAwesomeIcon icon={faMusic} size="2x" className="text-pink-500 mb-6 animate-pulse" />

        <Link
          to={url}
          className="inline-flex items-center gap-2 px-6 py-3 bg-green-600 hover:bg-green-700 text-white font-semibold rounded-xl shadow-lg transition duration-200"
        >
          {buttonText} <FontAwesomeIcon icon={faArrowRight} />
        </Link>
      </div>
    </div>
  );
}
